/**
 * Bulk-resolve spreadsheet identifiers to contacts.
 *
 * Wraps POST /group/admin/presets/resolve-contacts (site-admin only, rate
 * limited server-side). Read-only on the server: this never creates
 * anything, so there is no cache to invalidate. Creation still goes through
 * useCreatePresetAdmin().
 *
 * Data safety: the submitted values and the resolved names are PII. Never
 * log them - the caller surfaces counts only.
 */
import { useMutation } from "@tanstack/react-query";
import { usePymbleApi } from "./usePymbleApi";
import type {
  ResolveContactsRequest,
  ResolveContactsResponse,
} from "../components/presets/importTypes";

const RESOLVE_ENDPOINT = "/group/admin/presets/resolve-contacts";

export function useResolveContacts() {
  const { callApi } = usePymbleApi();

  return useMutation<ResolveContactsResponse, Error, ResolveContactsRequest>({
    mutationFn: async (body) => {
      const res = await callApi("POST", RESOLVE_ENDPOINT, { data: body });
      return res as ResolveContactsResponse;
    },
  });
}
